import { rest } from 'msw'

import { config } from '@percent/admin-dashboard/config'
import {
  buildInternalService,
  buildServiceRoleHolder,
  mockInternalServicesResponse,
  mockServiceRolesResponse
} from '@percent/admin-dashboard/fixtures/api/internalServices/mockInternalServices'

const services = `${config.urls.api}v1/admin/services`

export const internalServicesHandlers = [
  rest.get(services, (_, res, ctx) => res(ctx.status(200), ctx.json(mockInternalServicesResponse))),
  rest.post(services, (_, res, ctx) =>
    res(ctx.status(201), ctx.json({ object: 'service', data: buildInternalService() }))
  ),
  rest.get(`${services}/:serviceId/roles`, (_, res, ctx) => res(ctx.status(200), ctx.json(mockServiceRolesResponse))),
  rest.post(`${services}/:serviceId/roles`, (_, res, ctx) =>
    res(ctx.status(201), ctx.json({ object: 'service_role', data: buildServiceRoleHolder() }))
  ),
  rest.put(`${services}/:serviceId/roles/:holderId`, (_, res, ctx) =>
    res(ctx.status(200), ctx.json({ object: 'service_role', data: buildServiceRoleHolder() }))
  ),
  rest.delete(`${services}/:serviceId/roles/:holderId`, (_, res, ctx) => res(ctx.status(204))),
  rest.get(`${services}/:serviceId`, (req, res, ctx) =>
    res(
      ctx.status(200),
      ctx.json({ object: 'service', data: buildInternalService({ id: String(req.params.serviceId) }) })
    )
  ),
  rest.patch(`${services}/:serviceId`, (_, res, ctx) =>
    res(ctx.status(200), ctx.json({ object: 'service', data: buildInternalService() }))
  ),
  rest.delete(`${services}/:serviceId`, (_, res, ctx) => res(ctx.status(204)))
]
